(function() {
  function init() {
    var forms = document.querySelectorAll('.esc__sms-form');
    forms.forEach(function(form) {
      var input = form.querySelector('input[type="tel"]');
      var btn = form.querySelector('button[type="submit"]');
      var status = form.querySelector('.esc__success');
      if (!input || !btn || !status) return;

      var btnLabel = btn.textContent;
      var endpoint = 'https://' + form.dataset.h + '.' + form.dataset.d + '.com' + form.dataset.p + '?company_id=' + form.dataset.k;
      var listId = form.dataset.lid;

      function showStatus(msg, isError) {
        status.textContent = msg;
        status.style.color = isError ? '#ff6b6b' : '#d4f479';
        status.classList.add('is-visible');
      }

      function resetStatus() {
        status.textContent = '';
        status.classList.remove('is-visible');
      }

      function normalizePhone(raw) {
        var digits = raw.replace(/\D/g, '');
        if (digits.length === 10) return '+1' + digits;
        if (digits.length === 11 && digits[0] === '1') return '+' + digits;
        if (raw[0] === '+' && digits.length >= 10) return '+' + digits;
        return null;
      }

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        resetStatus();

        if (!input.value.trim()) {
          showStatus('Please enter your mobile number.', true);
          input.focus();
          return;
        }

        var phone = normalizePhone(input.value.trim());
        if (!phone) {
          showStatus('Please enter a valid 10-digit US mobile number.', true);
          input.focus();
          return;
        }

        btn.disabled = true;
        btn.textContent = 'Sending...';

        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Website SMS Capture',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      phone_number: phone
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId
                  }
                }
              }
            }
          })
        })
        .then(function(res) {
          if (res.ok || res.status === 202) {
            showStatus('You are signed up! Watch for a confirmation text.', false);
            input.value = '';
            input.disabled = true;
            btn.textContent = 'Signed Up';
          } else {
            return res.text().then(function(body) {
              var msg = 'Something went wrong. Please try again.';
              try {
                var parsed = JSON.parse(body);
                if (parsed.errors && parsed.errors[0] && parsed.errors[0].detail) {
                  msg = parsed.errors[0].detail;
                }
              } catch(ignored) {}
              throw new Error(msg);
            });
          }
        })
        .catch(function(err) {
          showStatus(err.message || 'Something went wrong. Please try again.', true);
          btn.disabled = false;
          btn.textContent = btnLabel;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
